<template>
  <div>
    <label v-if="label" class="block text-base font-medium text-gray-700">
      {{ label }}
    </label>
    <div class="relative" :class="{ 'mb-8': invalid }">
      <input
        :disabled="readonly"
        v-mask="'##/##/####'"
        :value="value"
        @input="updateValue"
        type="text"
        class="
          pr-10
          mt-1
          focus:ring-cyan-500 focus:border-cyan-500
          block
          w-full
          shadow-sm
          text-base
          border-gray-300
          rounded-md
          leading-none
        "
        :class="{ 'cursor-not-allowed': disabled }"
        placeholder="วว/ดด/ปปปป"
        @blur="onBlur"
      />
      <span v-if="invalid" class="absolute left-0 text-base text-red-600"
        >รูปแบบ วันที่ ไม่ถูกต้อง</span
      >
      <!-- clear button -->
      <button
        v-if="value && clearable"
        @click="clear"
        type="button"
        class="absolute inset-y-0 right-10 focus:outline-none"
        tabindex="-1"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 text-gray-300 hover:text-gray-400"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
      <!-- end clear button -->
      <span class="absolute right-0.5 bottom-0.5">
        <button
          :disabled="disabled"
          @click="toggleDatePicker"
          type="button"
          class="group px-2 py-2 rounded-md focus:outline-none"
          :class="{ 'cursor-not-allowed': disabled }"
          tabindex="-1"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6 text-cyan-600 group-hover:text-cyan-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        </button>
      </span>
      <span class="z-50 absolute shadow-xl" :class="datePickerClass">
        <DatePicker
          @input="updateValueDatePicker"
          :value="value"
          v-on-clickaway="clickOutside"
          v-if="isShowDatePicker"
          @onChange="onChange"
          :disabledDateFn="disabledDateFn"
        />
      </span>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import DatePicker from '@/components/DatePicker'
import moment from 'moment'

export default {
  mixins: [clickaway],

  components: {
    DatePicker,
  },

  props: {
    label: {
      type: String,
      default: '',
    },

    value: {
      type: [Date, String],
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    datePickerClass: {
      type: String,
    },

    resetValidate: {
      type: Boolean,
      default: false,
    },

    disabledDateFn: {
      type: Function,
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    clearable: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isShowDatePicker: false,
      invalid: false,
    }
  },

  watch: {
    resetValidate(value) {
      if (value === true) {
        this.invalid = false
        this.$emit('resetValidateCompleted')
      }
    },
  },

  methods: {
    validateDate(value) {
      const format = 'DD/MM/YYYY'
      this.invalid = moment(value, format, false).isValid() ? false : true
    },

    onBlur() {
      if (this.value) {
        this.validateDate(this.value)
      }
      this.$emit('invalid', this.invalid)
    },

    onChange(type) {
      if (type === 'date') {
        this.isShowDatePicker = false
      }
    },

    clickOutside() {
      this.isShowDatePicker = false
    },

    toggleDatePicker() {
      this.isShowDatePicker = !this.isShowDatePicker
    },

    updateValue(event) {
      if (!event.target.value) {
        this.invalid = false
        this.$emit('invalid', this.invalid)
      }
      this.$emit('input', event.target.value)
    },

    updateValueDatePicker(value) {
      this.validateDate(value)
      this.$emit('invalid', this.invalid)
      this.$emit('input', value)
    },

    clear() {
      this.invalid = false
      this.$emit('invalid', this.invalid)
      this.$emit('input', '')
    },
  },
}
</script>
